module.exports = __webpack_public_path__ + "c6fe3dd6c18a120c9771b9cb60d4d48b.MP3";